import { useCallback } from "react";
import axios from "axios";
import { useAuth } from "@clerk/react";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const REF_KEY = "rn_ref";

export function useApi() {
  const { getToken } = useAuth();
  return useCallback(async (method, url, data) => {
    const token = await getToken();
    const res = await axios({ method, url: `${API}${url}`, data, headers: { Authorization: `Bearer ${token}` } });
    return res.data;
  }, [getToken]);
}

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(", ");
  return d || "Something went wrong";
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

export const fmtDate = (s) => (s ? new Date(s).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");
